import { createAction } from '@reduxjs/toolkit';

export const PROCESS_DTMF_STRING_ACTION_TYPE = 'saga/processDtmfString';
export const processDtmfStringAction = createAction(PROCESS_DTMF_STRING_ACTION_TYPE);
